// extracted by mini-css-extract-plugin
var _1 = "src-common-Notifications-module__notification";
var _2 = "src-common-Notifications-module__notifications";
var _3 = "src-common-Notifications-module__parameters";
var _4 = "src-common-Notifications-module__timestamp";
var _5 = "src-common-Notifications-module__title";
export { _1 as "notification", _2 as "notifications", _3 as "parameters", _4 as "timestamp", _5 as "title" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"notification\":\"src-common-Notifications-module__notification\",\"notifications\":\"src-common-Notifications-module__notifications\",\"parameters\":\"src-common-Notifications-module__parameters\",\"timestamp\":\"src-common-Notifications-module__timestamp\",\"title\":\"src-common-Notifications-module__title\"}";
        // 1776408147892
        var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  